import { identifiersStatuses, itemIdentifierLabels, usCountryCode } from './constants'

export const haveAllItemsHSCode = product => {
  return product.inventory_items.every(item => item.hs_code)
}

export const haveAllItemsCountry = product => {
  return product.inventory_items.every(item => item.country)
}

export const haveAllItemsWeight = product => {
  return product.inventory_items.every(item => item.weight && Number(item.weight) > 0)
}

export const haveAllItemsUnitCost = product => {
  return product.inventory_items.every(item => item.unit_cost && Number(item.unit_cost) > 0)
}

export const haveAllItemsExportPrice = product => {
  return product.inventory_items.every(item => item.export_details)
}

export const getExportPriceCountriesInfo = (exportPrice = [], t) => {
  if (exportPrice?.length === 1) {
    return t('1 país')
  }
  return t('{{count}} países', { count: exportPrice?.length })
}

export const isItemIdentifiersComplete = item => !item.missing_identifiers?.length

export const getIncompleteIdentifiersCount = product => {
  return product.inventory_items.filter(item => !isItemIdentifiersComplete(item)).length
}

export const getProductIdentifiersStatus = product => {
  const incompleteCount = getIncompleteIdentifiersCount(product)

  if (incompleteCount === 0) return identifiersStatuses.completed
  if (incompleteCount === product.inventory_items.length) return identifiersStatuses.missing

  return identifiersStatuses.partial
}

export const getItemIdentifiers = item => {
  const usExportDetail = item.export_details?.find(exportDetail => exportDetail.country?.code === usCountryCode)

  const identifiers = [
    { label: itemIdentifierLabels.barcode, value: item.barcode },
    { label: itemIdentifierLabels.ns_pid, value: item.ns_pid },
    { label: itemIdentifierLabels.mid_code, value: usExportDetail?.mid_code },
    { label: itemIdentifierLabels.hts_code, value: usExportDetail?.country_customs_code },
  ]

  return identifiers.filter(identifier => identifier.value)
}
